import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6"
}
const _hoisted_2 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_3 = { class: "rounded-2xl bg-white/10 px-4 py-3 text-sm text-blue-50" }
const _hoisted_4 = { class: "mt-1 font-semibold" }
const _hoisted_5 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_6 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-5" }
const _hoisted_7 = { class: "flex items-end" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-5" }
const _hoisted_10 = { class: "text-sm font-semibold text-slate-500" }
const _hoisted_11 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_12 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_13 = { class: "grid gap-5 xl:grid-cols-3" }
const _hoisted_14 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_15 = { class: "mt-4 space-y-3" }
const _hoisted_16 = { class: "flex items-center justify-between text-sm" }
const _hoisted_17 = { class: "font-medium capitalize text-slate-700" }
const _hoisted_18 = { class: "text-slate-500" }
const _hoisted_19 = { class: "mt-1 h-2 overflow-hidden rounded-full bg-slate-100" }
const _hoisted_20 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_21 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_22 = { class: "mt-4 space-y-4" }
const _hoisted_23 = { class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between" }
const _hoisted_24 = { class: "font-semibold text-slate-900" }
const _hoisted_25 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_26 = { class: "font-bold text-blue-800 sm:text-right" }
const _hoisted_27 = { class: "mt-3 grid grid-cols-1 gap-2 text-xs text-slate-500 sm:grid-cols-2" }
const _hoisted_28 = {
  key: 0,
  class: "py-8 text-center text-sm italic text-slate-400"
}
const _hoisted_29 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_30 = { class: "mt-4 space-y-4" }
const _hoisted_31 = { class: "flex items-center justify-between text-sm" }
const _hoisted_32 = { class: "font-medium capitalize text-slate-700" }
const _hoisted_33 = { class: "font-semibold text-slate-900" }
const _hoisted_34 = { class: "mt-2 h-2 overflow-hidden rounded-full bg-slate-100" }
const _hoisted_35 = { class: "mt-1 text-xs text-slate-500" }
const _hoisted_36 = {
  key: 0,
  class: "py-8 text-center text-sm italic text-slate-400"
}
const _hoisted_37 = { class: "grid gap-5 xl:grid-cols-2" }
const _hoisted_38 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_39 = { class: "mt-4 flex h-56 items-end gap-2 border-b border-slate-100 pb-2" }
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "mt-2 flex justify-between text-[11px] text-slate-400" }
const _hoisted_42 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_43 = { class: "mt-4 max-h-64 space-y-3 overflow-y-auto pr-1" }
const _hoisted_44 = { class: "flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3" }
const _hoisted_45 = { class: "font-semibold text-slate-900" }
const _hoisted_46 = { class: "text-xs text-slate-500" }
const _hoisted_47 = { class: "font-bold text-blue-800 sm:text-right" }
const _hoisted_48 = { class: "mt-2 h-2 overflow-hidden rounded-full bg-slate-100" }
const _hoisted_49 = {
  key: 0,
  class: "py-8 text-center text-sm italic text-slate-400"
}
const _hoisted_50 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_51 = { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }
const _hoisted_52 = { class: "overflow-x-auto" }
const _hoisted_53 = { class: "min-w-full text-sm" }
const _hoisted_54 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "px-4 py-3 text-slate-600 whitespace-nowrap" }
const _hoisted_58 = { class: "px-4 py-3" }
const _hoisted_59 = { class: "font-medium text-slate-900 whitespace-nowrap" }
const _hoisted_60 = { class: "text-xs text-slate-500 whitespace-nowrap" }
const _hoisted_61 = { class: "px-4 py-3 text-slate-700 whitespace-nowrap" }
const _hoisted_62 = { class: "px-4 py-3 text-slate-700 whitespace-nowrap" }
const _hoisted_63 = { class: "px-4 py-3 text-right font-semibold text-slate-900 whitespace-nowrap" }
const _hoisted_64 = { class: "px-4 py-3" }
const _hoisted_65 = { class: "px-4 py-3" }

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import { GET_PAYMENT_DASHBOARD } from '@/store/paymentDashboard.module';
import type {
  PaymentDashboardData,
  PaymentDashboardKpis,
  PaymentSummaryItem,
} from '@/types/domain';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentDashboardView',
  props: {
    isEmbed: { type: Boolean, default: false }
  },
  setup(__props: any) {



const store = useStore();
const isLoading = ref(true);
const donationType = ref('all');
const paymentStatus = ref('');
const donationTypeOptions = [
  { value: 'all', label: 'Semua' },
  { value: 'iuran_sukarela', label: 'Iuran Sukarela' },
  { value: 'kontribusi_sukarela', label: 'Kontribusi Sukarela' },
];
const paymentStatusOptions = [
  { value: '', label: 'Semua' },
  { value: 'pending', label: 'Menunggu' },
  { value: 'settlement', label: 'Lunas' },
  { value: 'expired', label: 'Kedaluwarsa' },
  { value: 'failed', label: 'Gagal' },
  { value: 'refunded', label: 'Dikembalikan' },
];

const today = new Date();
const start = new Date(today);
start.setDate(today.getDate() - 29);

const toDateInput = (date: Date) => date.toISOString().slice(0, 10);
const startDate = ref(toDateInput(start));
const endDate = ref(toDateInput(today));

const dashboard = computed<PaymentDashboardData>(() => store.getters.paymentDashboard || {});
const kpis = computed<PaymentDashboardKpis>(() => dashboard.value.kpis || {});
const statusSummary = computed<PaymentSummaryItem[]>(() => dashboard.value.statusSummary || []);
const typeSummary = computed<PaymentSummaryItem[]>(() => dashboard.value.typeSummary || []);
const methodSummary = computed<PaymentSummaryItem[]>(() => dashboard.value.methodSummary || []);
const facultySummary = computed<PaymentSummaryItem[]>(() => dashboard.value.facultySummary || []);
const dailyTrend = computed<PaymentSummaryItem[]>(() => dashboard.value.dailyTrend || []);
const recentPayments = computed<PaymentSummaryItem[]>(() => dashboard.value.recentPayments || []);

const filtersLabel = computed(() => `${formatShortDate(startDate.value)} - ${formatShortDate(endDate.value)}`);

const maxStatusCount = computed(() => Math.max(...statusSummary.value.map((item) => Number(item.count || 0)), 1));
const maxMethodAmount = computed(() => Math.max(...methodSummary.value.map((item) => Number(item.totalAmount || 0)), 1));
const maxFacultyAmount = computed(() => Math.max(...facultySummary.value.map((item) => Number(item.totalAmount || 0)), 1));
const maxTrendAmount = computed(() => Math.max(...dailyTrend.value.map((item) => Number(item.totalAmount || 0)), 1));

const kpiCards = computed(() => [
  {
    title: 'Total Masuk',
    value: formatIDR(kpis.value.totalAmount),
    description: `${kpis.value.totalCount || 0} transaksi`,
  },
  {
    title: 'Sudah Lunas',
    value: formatIDR(kpis.value.settledAmount),
    description: `${kpis.value.settledCount || 0} transaksi settlement`,
  },
  {
    title: 'Menunggu',
    value: formatIDR(kpis.value.pendingAmount),
    description: `${kpis.value.pendingCount || 0} transaksi pending`,
  },
  {
    title: 'Gagal/Expired',
    value: `${(kpis.value.failedCount || 0) + (kpis.value.expiredCount || 0)}`,
    description: `Failed ${kpis.value.failedCount || 0} · Expired ${kpis.value.expiredCount || 0}`,
  },
  {
    title: 'Rasio Lunas',
    value: `${kpis.value.settlementRate || 0}%`,
    description: 'Dari total transaksi periode ini',
  },
]);

const getData = async () => {
  isLoading.value = true;
  try {
    await store.dispatch(GET_PAYMENT_DASHBOARD, {
      data: {
        startDate: startDate.value,
        endDate: endDate.value,
        donationType: donationType.value,
        paymentStatus: paymentStatus.value || undefined,
      },
    });
  } finally {
    isLoading.value = false;
  }
};

onMounted(getData);

const formatIDR = (amount?: number | string | null) => {
  const value = Number(amount || 0);
  return `Rp ${value.toLocaleString('id-ID')}`;
};

const formatDate = (value?: string) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
};

const formatShortDate = (value?: string) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('id-ID', { day: '2-digit', month: 'short' });
};

const formatDonationType = (type?: string) => {
  if (!type) return '-';
  return type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

const barWidth = (value: number | string, max: number) => {
  const numericValue = Number(value || 0);
  if (!numericValue || !max) return 0;
  return Math.max(4, Math.round((numericValue / max) * 100));
};

const statusBarClass = (status?: string) => {
  if (status === 'settlement') return 'bg-green-500';
  if (status === 'pending') return 'bg-yellow-500';
  if (status === 'failed') return 'bg-red-500';
  if (status === 'expired') return 'bg-slate-400';
  return 'bg-purple-500';
};

const statusBadgeClass = (status?: string) => {
  if (status === 'settlement') return 'bg-green-100 text-green-700';
  if (status === 'pending') return 'bg-yellow-100 text-yellow-700';
  if (status === 'failed') return 'bg-red-100 text-red-700';
  if (status === 'expired') return 'bg-slate-200 text-slate-700';
  if (status === 'refunded') return 'bg-purple-100 text-purple-700';
  return 'bg-slate-100 text-slate-600';
};

const methodBadgeClass = (method?: string) =>
  method === 'midtrans' ? 'bg-blue-100 text-blue-700' : 'bg-slate-200 text-slate-700';

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.isEmbed ? '' : 'min-h-screen')
  }, [
    (!__props.isEmbed)
      ? (_openBlock(), _createBlock(Breadcrumb, {
          key: 0,
          breadcrumb: "dashboard-pembayaran"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(__props.isEmbed ? 'mt-0 space-y-5' : 'mt-8 space-y-5')
    }, [
      (!__props.isEmbed)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Dashboard Pembayaran"),
                _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Pantau pembayaran iuran sukarela dan kontribusi sukarela berdasarkan status, metode, fakultas, dan tren harian. ")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm font-medium text-blue-100" }, "Periode", -1)),
                _createElementVNode("p", _hoisted_4, _toDisplayString(filtersLabel.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Mulai", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
              type: "date",
              class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            }, null, 512), [
              [_vModelText, startDate.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Sampai", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
              type: "date",
              class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            }, null, 512), [
              [_vModelText, endDate.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Jenis", -1)),
            _createVNode(AppSelect, {
              modelValue: donationType.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((donationType).value = $event)),
              options: donationTypeOptions
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status", -1)),
            _createVNode(AppSelect, {
              modelValue: paymentStatus.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentStatus).value = $event)),
              options: paymentStatusOptions
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              disabled: isLoading.value,
              class: "w-full rounded-lg bg-blue-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60",
              onClick: getData
            }, _toDisplayString(isLoading.value ? 'Memuat...' : 'Terapkan'), 9, _hoisted_8)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiCards.value, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.title,
            class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          }, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(card.title), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(card.value), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(card.description), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Status Pembayaran", -1)),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusSummary.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.status
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.status), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.count) + " transaksi", 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["h-full rounded-full", statusBarClass(item.status)]),
                    style: _normalizeStyle({ width: `${barWidth(item.count, maxStatusCount.value)}%` })
                  }, null, 6)
                ]),
                _createElementVNode("p", _hoisted_20, _toDisplayString(formatIDR(item.totalAmount)), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Jenis Pembayaran", -1)),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeSummary.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.type,
                class: "rounded-xl bg-slate-50 p-4"
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(formatDonationType(item.type)), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(item.count) + " transaksi", 1)
                  ]),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(formatIDR(item.totalAmount)), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", null, "Lunas: " + _toDisplayString(formatIDR(item.settledAmount)), 1),
                  _createElementVNode("span", null, "Pending: " + _toDisplayString(formatIDR(item.pendingAmount)), 1)
                ])
              ]))
            }), 128)),
            (typeSummary.value.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Belum ada data pada periode ini."))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Metode Pembayaran", -1)),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(methodSummary.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.method
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(item.method), 1),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(formatIDR(item.totalAmount)), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "h-full rounded-full bg-blue-700",
                    style: _normalizeStyle({ width: `${barWidth(item.totalAmount, maxMethodAmount.value)}%` })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_35, _toDisplayString(item.count) + " transaksi", 1)
              ]))
            }), 128)),
            (methodSummary.value.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "Belum ada data metode pembayaran."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Tren Harian", -1)),
          _createElementVNode("div", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyTrend.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.date,
                class: "group flex min-w-[22px] flex-1 flex-col items-center justify-end",
                title: `${formatDate(item.date)} - ${formatIDR(item.totalAmount)}`
              }, [
                _createElementVNode("div", {
                  class: "w-full rounded-t bg-blue-700 transition-all group-hover:bg-blue-500",
                  style: _normalizeStyle({ height: `${barWidth(item.totalAmount, maxTrendAmount.value)}%`, minHeight: item.totalAmount ? '8px' : '2px' })
                }, null, 4)
              ], 8, _hoisted_40))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("span", null, _toDisplayString(dailyTrend.value[0]?.date ? formatShortDate(dailyTrend.value[0].date) : '-'), 1),
            _createElementVNode("span", null, _toDisplayString(dailyTrend.value[dailyTrend.value.length - 1]?.date ? formatShortDate(dailyTrend.value[dailyTrend.value.length - 1].date) : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Breakdown Fakultas", -1)),
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facultySummary.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.facultyId || item.facultyName,
                class: "rounded-xl border border-slate-100 p-3"
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_45, _toDisplayString(item.facultyName), 1),
                    _createElementVNode("p", _hoisted_46, _toDisplayString(item.count) + " transaksi · kode " + _toDisplayString(item.kodeUnik || '-'), 1)
                  ]),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(formatIDR(item.totalAmount)), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", {
                    class: "h-full rounded-full bg-emerald-500",
                    style: _normalizeStyle({ width: `${barWidth(item.totalAmount, maxFacultyAmount.value)}%` })
                  }, null, 4)
                ])
              ]))
            }), 128)),
            (facultySummary.value.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Belum ada data fakultas."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _cache[18] || (_cache[18] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Pembayaran Terbaru"),
            _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "10 transaksi terbaru sesuai filter dashboard.")
          ], -1)),
          _createVNode(_component_router_link, {
            to: "/donasi",
            class: "rounded-full bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100"
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" Lihat Donasi ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("table", _hoisted_53, [
            _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-blue-900" }, [
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Tanggal"),
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Nama"),
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Jenis"),
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Fakultas"),
                _createElementVNode("th", { class: "px-4 py-3 text-right text-sm font-semibold text-blue-100" }, "Nominal"),
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Metode"),
                _createElementVNode("th", { class: "px-4 py-3 text-left text-sm font-semibold text-blue-100" }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_54, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-4"
                      }, [...(_cache[19] || (_cache[19] = [
                        _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (recentPayments.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "px-4 py-10 text-center text-sm italic text-slate-400"
                      }, "Belum ada pembayaran pada periode ini.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(recentPayments.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id,
                        class: "hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_57, _toDisplayString(formatDate(item.paidAt || item.date || item.createdAt)), 1),
                        _createElementVNode("td", _hoisted_58, [
                          _createElementVNode("p", _hoisted_59, _toDisplayString(item.name || '-'), 1),
                          _createElementVNode("p", _hoisted_60, _toDisplayString(item.email || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_61, _toDisplayString(formatDonationType(item.donationType)), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(item.facultyName || '-'), 1),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(formatIDR(item.grossAmount || item.amount)), 1),
                        _createElementVNode("td", _hoisted_64, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-medium capitalize", methodBadgeClass(item.paymentMethod)])
                          }, _toDisplayString(item.paymentMethod || '-'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_65, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-medium capitalize", statusBadgeClass(item.paymentStatus)])
                          }, _toDisplayString(item.paymentStatus || 'pending'), 3)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})